import type { IContextualMenuItemProps } from "@fluentui/react/lib/ContextualMenu";
import type { IComponentAsProps } from "@fluentui/utilities/lib/IComponentAs";
import * as React from "react";
import { getMenuHeaderClassNames } from "./Menu.classNames";

export const MenuHeaderWithActionV8 = (
  props: IComponentAsProps<IContextualMenuItemProps>
) => {
  const { item } = props;
  const classes = getMenuHeaderClassNames();
  return (
    <div className={classes.root}>
      {item.text}
      <button className={classes.button} onClick={item.data.action.onClick}>
        {item.data.action.text}
      </button>
    </div>
  );
};
